import {useEffect, useState} from 'react';
import {useQueryClient} from 'react-query';
import {useDispatch} from 'react-redux';
import {GUARANTOR_INFO} from '../../../../../config/cacheKey';
import {IDocument} from '../../../../../models/common.model';
import {ILoans} from '../../../../../models/guarantor.model';
import {
    changeRouteType,
    getpervInnerState,
} from '../../../../../redux/handleBackBtn/handleBackBtnSlice';
import {setHeaderTitle} from '../../../../../redux/headerTitle/headerTitleSlice';
import AttachedFile from '../../../loansTab/loanDetail/guarantee/attachedFile';
import {IInnerStateHomeMenu} from '../../IHomeMenu';
import {IMultiImage} from '../../../loansTab/attachedImage/IMultiImage';
import FullScreenMultiImage from '../../../loansTab/attachedImage/fullScreenMultiImage';
import FullScreenMultiImageSkeleton from '../../../loansTab/attachedImage/fullScreenMultiImageSkeleton';

export default function GuarantorFile({setState}: IInnerStateHomeMenu) {
    const msg = `تسهیلات`;
    const randomKeyForDispatch = Math.random();
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    const guarantorInfo = queryClient.getQueryData(GUARANTOR_INFO) as ILoans;
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        dispatch(
            setHeaderTitle({
                color: 'var(--header-color)',
                header: msg,
                parentRoute: 'DetailAttachedFile',
            })
        );
        dispatch(changeRouteType({routeType: 'child'}));
        dispatch(
            getpervInnerState({
                prevInnerState: `DetailAttachedFile ${randomKeyForDispatch}`,
            })
        );
    }, []);
    setTimeout(() => setLoading(false), 1000);
    if (loading) {
        return <FullScreenMultiImageSkeleton />;
    }
    return (
        <div className="p-5">
            <FullScreenMultiImage data={guarantorInfo.guarantorInfo.files} />
        </div>
    );
}
